    <div fxShow.gt-sm fxHide.lt-md *ngIf="showMessage" fxLayout="row" fxLayoutAlign="space-between end"
         style="margin-bottom: 25px;padding: 20px; background-color: #C5DBF2; border-radius: 5px;">
      <div fxLayout="row">
        <mat-icon style="margin-right:20px">info</mat-icon>
        <div fxLayout="column" *ngIf="message">
          <span style="font-weight:700; color:var(--primary);">Μήνυμα για εσάς</span>
          <span style="margin-top:5px; color:var(--primary);">{{message.subject}}</span>
        </div>
      </div>

      <div>
        <button mat-raised-button style="margin-right: 20px; background-color: var(--secondaryBlue);  color:white; border-radius: 50px;" (click)="displayMessage(message.id)">Προβολή</button>
        <button class="closeButton" mat-flat-button style="margin-right: 20px; border:1px solid gray; background-color: transparent;  color:black; border-radius: 50px;" (click)="hideMessage()">Κλείσιμο</button>
      </div>
    </div>

    <div fxLayout="column" fxShow.lt-md fxHide.gt-sm>
        <div fxLayout="row" style="background-color: #C5DBF2; padding: 15px;">
            <mat-icon style="margin-right:20px">info</mat-icon>
            <div fxLayout="column" *ngIf="message">
                <span style="font-weight:700; color:var(--primary);">Μήνυμα για εσάς</span>
                <span style="margin-top:5px; color:var(--primary);">{{message.subject}}</span>

                <div fxLayout="row" style="margin-top: 15px;" fxLayoutAlign="center center">
                    <button mat-raised-button style="margin-right: 5px; background-color: var(--secondaryBlue);  color:white; " (click)="displayMessage(message.id)">Προβολή</button>
                    <button class="closeButton" mat-flat-button style="margin-right: 20px; border:1px solid gray; background-color: transparent;  color:black;" (click)="hideMessage()">Κλείσιμο</button>
                </div>
            </div>


        </div>
    </div>
